import React, { useState } from "react";
import { api } from "@/lib/api";
import { PaperPlaneTilt } from "@phosphor-icons/react";

// Iter207 — Componente riutilizzabile di iscrizione newsletter.
// Usato nel footer pubblico (variant="footer") e in fondo agli articoli del
// blog (variant="article"). L'API è la stessa: POST /public/newsletter-subscribe.
//
// Props:
//   • variant: "footer" | "article"   → cambia layout ed estetica
//   • source:  string                 → tracciamento fonte iscrizione
export default function NewsletterOptIn({ variant = "footer", source }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done | err
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("loading");
    try {
      const r = await api.post("/public/newsletter-subscribe", {
        email: email.trim(),
        source: source || variant,
      });
      setMsg(r.data?.message || "Iscrizione confermata");
      setState("done");
      setEmail("");
    } catch (err) {
      setMsg(err?.response?.data?.detail || "Errore, riprova");
      setState("err");
    }
  };

  // ============ VARIANT: FOOTER (compatto, colonna) ============
  if (variant === "footer") {
    return (
      <div data-testid="newsletter-optin">
        <div className="label-eyebrow mb-2">Newsletter</div>
        <p className="text-sm text-muted-foreground mb-3">
          Ricevi novità, guide e casi studio ogni mese.
        </p>
        {state === "done" ? (
          <div
            className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2"
            data-testid="newsletter-success"
          >
            {msg}
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-2">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tua@email.it"
              className="w-full h-9 rounded-md border border-slate-300 px-3 text-sm focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit"
              disabled={state === "loading"}
              className="w-full h-9 rounded-md ht-gradient text-white text-sm font-semibold disabled:opacity-60"
              data-testid="newsletter-submit"
            >
              {state === "loading" ? "Iscrizione…" : "Iscriviti"}
            </button>
            {state === "err" && (
              <div
                className="text-[11px] text-red-600"
                data-testid="newsletter-error"
              >
                {msg}
              </div>
            )}
            <p className="text-[10px] text-muted-foreground">
              Zero spam. Puoi disiscriverti in qualsiasi momento.
            </p>
          </form>
        )}
      </div>
    );
  }

  // ============ VARIANT: ARTICLE (card grande viola, inline) ============
  return (
    <div
      className="my-12 rounded-2xl ht-gradient p-8 md:p-10 text-white shadow-xl"
      data-testid="newsletter-optin-article"
    >
      <div className="flex flex-col md:flex-row md:items-center gap-6">
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-wider text-white/70 font-bold mb-2">
            Newsletter Housetag
          </div>
          <h3 className="font-display text-2xl md:text-3xl font-bold leading-tight">
            Ti è piaciuto l'articolo?
          </h3>
          <p className="text-white/85 mt-2 leading-relaxed">
            Iscriviti per ricevere ogni mese guide, casi studio e novità pensate
            per professionisti del real estate. Niente spam, promesso.
          </p>
        </div>
        <div className="md:w-[340px] w-full">
          {state === "done" ? (
            <div
              className="rounded-md bg-white/15 border border-white/30 px-4 py-3 text-sm font-medium"
              data-testid="newsletter-success"
            >
              ✓ {msg}
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-2">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tua@email.it"
                className="w-full h-11 rounded-md bg-white/95 text-slate-900 placeholder:text-slate-400 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-white"
                data-testid="newsletter-email-input"
              />
              <button
                type="submit"
                disabled={state === "loading"}
                className="w-full h-11 rounded-md bg-white text-purple-700 text-sm font-semibold flex items-center justify-center gap-2 hover:bg-purple-50 transition-colors disabled:opacity-60"
                data-testid="newsletter-submit"
              >
                {state === "loading" ? (
                  "Iscrizione…"
                ) : (
                  <>
                    Iscriviti <PaperPlaneTilt size={14} weight="fill" />
                  </>
                )}
              </button>
              {state === "err" && (
                <div
                  className="text-xs text-white/90 bg-red-500/20 rounded px-2 py-1"
                  data-testid="newsletter-error"
                >
                  {msg}
                </div>
              )}
              <p className="text-[10px] text-white/70 text-center pt-1">
                Iscrivendoti accetti la nostra Privacy Policy.
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
